export default __webpack_public_path__ + "static/media/cinc_main.72988bd1.png";